import { defineStore } from 'pinia'
import type { AuthTokens } from '../types/model'
import type { AuthLoginSuccessResponse } from '../types/api'
import type { Province } from '@/modules/Core/types/model/province'

interface State {
  tokens: AuthTokens
  isSuperAdmin: boolean | null
  province: Province | null
  countryId: null | number
  isAuthenticated: boolean
}

function initState() {
  return {
    tokens: {
      accessToken: '',
      refreshToken: '',
    },
    isSuperAdmin: null,
    province: null,
    countryId: 0,
    isAuthenticated: false,
  } as State
}

export const useAuthStore = defineStore('auth', {
  state: () => ({ ...initState() }),
  actions: {
    setLoginState(data: AuthLoginSuccessResponse) {
      this.tokens = data.tokens
      this.isSuperAdmin = data.isSuperAdmin
      this.province = data.legalLoginProvince
      this.countryId = data.countryId
      this.isAuthenticated = true
    },
    setToken(data: AuthTokens) {
      this.tokens = data
    },
    logout() {
      this.isAuthenticated = false
      this.$reset()
    },
  },
  persist: {
    storage: window.localStorage,
  },
})

export default useAuthStore
